var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal",class:{ 'modal--dark': _vm.dark }},[_c('h3',{staticClass:"modal__title",class:{ 'modal__title--dark': _vm.dark }},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"modal__text",class:{ 'modal__text--dark': _vm.dark }},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }